export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/harvest-img1-d141fb4117af50b9d912227eca094905.jpg";